<template>
    <section class="border rounded p-3 my-3">
        <h6>Отчёты для аннулирования</h6>
        <b-alert show variant="warning">После окончательного согласования отчёты исключаются из расчётов. Отменить аннулирование через интерфейс нельзя.</b-alert>
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <p v-if="!processId" class="text-muted mb-0">Сначала выберите объект.</p>
        <template v-else>
            <b-form-input v-model="search" size="sm" placeholder="Найти по точному номеру отчёта" class="mb-2" />
            <small v-if="options.length >= 500" class="text-muted">Показаны последние 500 отчётов. Для более ранних введите номер.</small>
            <div class="annulment-report-options">
                <b-form-checkbox v-for="row in filteredOptions" :key="row.shift_id" :checked="selected(row.shift_id)"
                    :disabled="Boolean(row.reserved_request_id && Number(row.reserved_request_id) !== Number(requestId))" @change="toggle(row, $event)">
                    №{{ row.shift_id }} · {{ formatDate(row.date_time_begin) }}
                    <small v-if="row.reserved_request_id && Number(row.reserved_request_id) !== Number(requestId)"> — уже в открытой заявке</small>
                </b-form-checkbox>
            </div>
            <small v-if="loading">Загрузка отчётов…</small>
            <small v-else-if="!options.length">Действующих отчётов нет.</small>
            <b-input-group v-if="value.length" size="sm" class="my-2">
                <AppTextarea v-model="commonReason" maxlength="100" placeholder="Общая причина" />
                <b-input-group-append><b-button @click="applyReason">Применить ко всем</b-button></b-input-group-append>
            </b-input-group>
            <div v-for="row in value" :key="row.shift_id" class="d-flex align-items-center mt-2">
                <span class="mr-2 text-nowrap">№{{ row.shift_id }}</span>
                <AppTextarea :value="row.reason" size="sm" maxlength="100" placeholder="Причина аннулирования" @input="reason(row.shift_id, $event)" />
                <b-button size="sm" variant="link" aria-label="Убрать отчёт" @click="toggle(row, false)">×</b-button>
            </div>
        </template>
    </section>
</template>
<script>
import api from '@/utils/api';
export default {
    props: {value: {type: Array, default: () => []}, processId: [Number, String], typeId: [Number, String], requestId: [Number, String]},
    data: () => ({options: [], loading: false, error: '', search: '', commonReason: '', revision: 0, searchTimer: null}),
    computed: {filteredOptions() { return this.options.filter(row => !this.search || String(row.shift_id).includes(this.search.trim())); }},
    watch: {
        processId: {immediate: true, handler(value, previous) { if (previous && Number(previous) !== Number(value)) this.$emit('input', []); this.load(); }},
        typeId() { this.load(); },
        search() { clearTimeout(this.searchTimer); this.searchTimer = setTimeout(() => this.load(), 250); }
    },
    beforeDestroy() { ++this.revision; clearTimeout(this.searchTimer); },
    methods: {
        formatDate(value) { return value ? this.$moment(value).format('DD.MM.YYYY HH:mm') : ''; },
        selected(id) { return this.value.some(row => Number(row.shift_id) === Number(id)); },
        toggle(row, checked) { this.$emit('input', checked ? this.selected(row.shift_id) ? this.value : this.value.concat({shift_id: Number(row.shift_id), reason: ''}) : this.value.filter(item => Number(item.shift_id) !== Number(row.shift_id))); },
        reason(id, reason) { this.$emit('input', this.value.map(row => row.shift_id === id ? {...row, reason} : row)); },
        applyReason() { this.$emit('input', this.value.map(row => ({...row, reason: this.commonReason.trim()}))); },
        async load() {
            const revision = ++this.revision;
            this.options = []; this.error = '';
            if (!this.processId || !this.typeId) return;
            this.loading = true;
            try {
                const {data} = await api.get('/api/requests/items/report-annulment/options', {params: {request_type_id: this.typeId, building_process_id: this.processId,
                    q: this.search.trim(), selected_ids: this.value.map(row => row.shift_id).concat(String(this.$route.query.reports || '').split(',')).join(',')}});
                if (revision !== this.revision) return;
                this.options = data.reports || [];
                if (!this.requestId && !this.value.length && this.$route.query.reports) {
                    const ids = String(this.$route.query.reports).split(',').map(Number);
                    this.$emit('input', this.options.filter(row => ids.includes(Number(row.shift_id)) && !row.reserved_request_id).map(row => ({shift_id: Number(row.shift_id), reason: ''})));
                }
            } catch (e) { if (revision === this.revision) this.error = e.response && e.response.data.message || 'Не удалось загрузить отчёты.'; }
            finally { if (revision === this.revision) this.loading = false; }
        }
    }
};
</script>
<style scoped>.annulment-report-options {max-height: 240px; overflow-y: auto;}</style>
